import { z } from 'zod';

import { dashboardT } from '../../../lib/messages';
import { customTargetingFormSchema, liverampTargetingFormSchema } from '../advancedTargetingModel';
import { targetingFormSchema } from '../model';
import { TargetingStatus } from './model';

export const targetingBuilderFormSchema = z.object({
  name: z.string().trim().min(1, dashboardT('targetingBuilder.nameRequired')),
  status: z.enum(TargetingStatus),
  targeting: targetingFormSchema,
  bundlesCount: z.number().int().nonnegative(),
  ipsCount: z.number().int().nonnegative(),
  pendingBundleCsv: z.custom<File>().nullable(),
  pendingIpCsv: z.custom<File>().nullable(),
  customTargeting: customTargetingFormSchema.superRefine((value, context) => {
    value.groups.forEach((group, groupIndex) => {
      group.keys.forEach((key, keyIndex) => {
        if (!key.value.trim()) {
          context.addIssue({
            code: 'custom',
            path: ['groups', groupIndex, 'keys', keyIndex, 'value'],
            message: dashboardT('targetingBuilder.valueRequired'),
          });
        }
      });
    });
  }),
  liverampTargeting: liverampTargetingFormSchema.superRefine((value, context) => {
    value.groups.forEach((group, groupIndex) => {
      group.keys.forEach((key, keyIndex) => {
        if (!key.values.length) {
          context.addIssue({
            code: 'custom',
            path: ['groups', groupIndex, 'keys', keyIndex, 'values'],
            message: dashboardT('targetingBuilder.segmentRequired'),
          });
        }
      });
    });
  }),
});
